import { Footer } from '@components/Footer';
import { FullscreenLoadingSpinner } from '@components/Loading/FullscreenLoadingSpinner';
import { ProductLibraryBackground } from '@components/ProductLibraryBackground';
import { useTenant } from '@providers/Tenant';
import { MainTemplate } from '@templates/MainTemplate';
import { useProductLibraryQuery } from './hooks/useProductLibraryQuery';
import CategoriesLayout from './ui/categories-layout';
import ProductListLayout from './ui/product-list-layout';

export default function ProductLibraryPage() {
  const { isLoading, configurations, jobs } = useProductLibraryQuery();
  const { productCategories } = useTenant();

  if (isLoading) {
    return <FullscreenLoadingSpinner />;
  }

  return (
    <MainTemplate>
      <ProductLibraryBackground>
        {productCategories?.length ? (
          <CategoriesLayout productCategories={productCategories} configurations={configurations} jobs={jobs} />
        ) : (
          <ProductListLayout configurations={configurations} jobs={jobs} />
        )}
      </ProductLibraryBackground>
      <Footer />
    </MainTemplate>
  );
}
